export default __webpack_public_path__ + "static/media/mobileKeyboard.e123e576.png";